import { ModuleRegistry, setupAgTestIds } from 'ag-grid-community';
import { AllEnterpriseModule } from 'ag-grid-enterprise';

// AG Grid v33+ requires modules to be registered before any grid is created,
// otherwise it throws error #272. This runs as an import side effect so that it
// executes for every entry point that mounts <App /> — both the standalone build
// (app.tsx) and the PSP module build (psp/pspEntry.tsx). Keeping it here (rather
// than in a single entry file) prevents the PSP bundle from rendering grids
// against an unregistered ModuleRegistry.
ModuleRegistry.registerModules([AllEnterpriseModule]);

if (process.env.NODE_ENV !== 'production') {
  setupAgTestIds({ testIdAttribute: 'data-test' });
}
